import { CContainer, CProgress } from '@coreui/react'
import React, { useEffect } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { enToPersianChar, wizardStepDetection } from '../../../../components/helper'
import { useDispatch } from 'react-redux'
import { getIsFreeProductRequestAction } from '../../../../service/actions/purchaseActions'
import { useSelector } from 'react-redux'

const freePackageSteps = [{ number: 1, text: "اطلاعات کاربری" }, { number: 2, text: "انتخاب شماره" }, { number: 3, text: "توافق‌نامه خدمات" }, { number: 4, text: "فعالسازی" }]
const notFreePackageSteps = [{ number: 1, text: "اطلاعات کاربری" }, { number: 2, text: "انتخاب شماره" }, { number: 3, text: "توافق‌نامه خدمات" }, { number: 4, text: "صورت حساب" }, { number: 5, text: "فعالسازی" }]

const Steps = () => {
    const params = useParams()
    const dispatch = useDispatch()
    const location = useLocation()
    const isFreeProduct = useSelector((state: any) => state.purchaseReducer.getIsFreeProductResult)
    const getIsFreeProductPending = useSelector((state: any) => state.purchaseReducer.getIsFreeProductPending)

    console.log("isFreeProduct", isFreeProduct)
    useEffect(() => {
        if (params?.productId || location?.state?.productId) {
            dispatch(getIsFreeProductRequestAction(params?.productId || location?.state?.productId))
        }
    }, [])

    const stepDetectionByPackage = () => {
        if (getIsFreeProductPending) {
            return []
        } else {
            if (isFreeProduct) {
                return freePackageSteps
            } else {
                return notFreePackageSteps
            }
        }
    }
    const stepDetection = () => {
        const value = wizardStepDetection(params.step)?.number
        if (isFreeProduct) {
            return value === 1 ? 25 : value === 2 ? 50 : value === 3 ? 75 : value === 4 ? 100 : 0

        } else {
            return value === 1 ? 20 : value === 2 ? 40 : value === 3 ? 60 : value === 4 ? 80 : value === 5 ? 100 : 0

        }
    }
    return (
        <div className='step-context'>
            <div className='steps'>
                {stepDetectionByPackage().map((step: { number: number, text: string }, idx: number) => <div
                    className={`${wizardStepDetection(params.step)?.number === step.number ? 'active' :
                        wizardStepDetection(params.step)?.number > step.number ? 'passed' :
                            ''}`}
                    key={idx}>
                    <span>{enToPersianChar(step.number)}</span>
                    <label>{step.text}</label>
                </div>)}
            </div>
            <div className='progress-bar-context' >
                <CProgress color={`${stepDetection() === 100 ? 'success' : 'info'}`} variant="striped" value={stepDetection()} />
            </div>
        </div>
    )
}

export default Steps

export const TitleUpStepDisplay = () => {
    const params = useParams()
    const isFreeProduct = useSelector((state: any) => state.purchaseReducer.getIsFreeProductResult)

    return (
        <div className='title-up-step-context' >
            <CContainer>
                <h1>{wizardStepDetection(params.step, isFreeProduct)?.text}</h1>
            </CContainer>
        </div>
    )
}